import React from 'react';
import { ScoreboardColors, scoreboardColors } from 'widgets/Scoreboard/types';
import { Line } from '../Line';

export const TieLine = () => <Line color={scoreboardColors[ScoreboardColors.Green]} />;
